'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getProGalleryStyles = exports.getProGalleryStylesImp = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _consts = require('./consts');

var _consts2 = _interopRequireDefault(_consts);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isUndefined = function isUndefined(a) {
  return typeof a === 'undefined';
}; /* eslint-disable complexity */
/* eslint-disable no-eval */


var baseDefaultStyles = {
  gotStyleParams: false,
  selectedLayout: 0,
  isRTL: false,
  isVertical: false,
  gallerySize: 320,
  minItemSize: 120,
  groupSize: 3,
  chooseBestGroup: true,
  groupTypes: '1,2h,2v,3t,3b,3l,3r',
  cubeImages: false,
  cubeType: 'fill',
  smartCrop: false,
  fullscreen: true,
  allowSocial: true,
  allowDownload: false,
  allowTitle: true,
  allowDescription: false,
  loveButton: true,
  loveCounter: true,
  videoLoop: true,
  videoSound: false,
  videoSpeed: 1,
  videoPlay: 'hover',
  gallerySliderImageRatio: 0,
  galleryImageRatio: 2,
  numberOfImagesPerRow: 3,
  sharpParams: {
    quality: 90,
    usm: {} // do not apply usm - {usm_r: 0.66, usm_a: 1.00, usm_t: 0.01},
  },
  collageAmount: 0.8,
  collageDensity: 0.8,
  imageMargin: 10, //The renderer will do the /2 *2 for his pictures, the default is the margin between images (thats how it is in the settings menu. 50 = 50 between images)
  galleryMargin: 0,
  floatingImages: 0,
  viewMode: 'preview',
  galleryHorizontalAlign: 'center',
  galleryTextAlign: 'center',
  galleryVerticalAlign: 'center',
  enableInfiniteScroll: 1,
  itemClick: 'expand',
  cubeRatio: 1, //determine the ratio of the images when using grid (use 1 for squares grid)
  fixedColumns: 0, //determine the number of columns regardless of the screen size (use 0 to ignore)
  oneRow: false, //render the gallery as a single row with horizontal scroll
  showArrows: false,
  isSlideshow: false,
  hasThumbnails: false,
  galleryThumbnailsAlignment: 'bottom',
  thumbnailSpacings: 0,
  gridStyle: 0,
  titlePlacement: _consts2.default.placements.SHOW_ON_HOVER,
  hoveringBehaviour: _consts2.default.infoBehaviourOnHover.APPEARS,
  mobilePanorama: false,
  isAutoSlideshow: false,
  slideshowLoop: false,
  playButtonForAutoSlideShow: false,
  allowSlideshowCounter: false,
  autoSlideshowInterval: 4,
  arrowsSize: 23,
  slideshowInfoSize: 200,
  imageLoadingMode: _consts2.default.loadingMode.BLUR,
  scrollAnimation: _consts2.default.scrollAnimations.NO_EFFECT,
  overlayAnimation: _consts2.default.overlayAnimations.NO_EFFECT,
  imageHoverAnimation: _consts2.default.imageHoverAnimations.NO_EFFECT,
  expandAnimation: _consts2.default.expandAnimations.NO_EFFECT,
  itemBorderWidth: 0,
  itemBorderColor: 'color-5',
  itemBorderRadius: 0,
  itemEnableShadow: false,
  itemShadowOpacityAndColor: { value: 'rgba(0, 0, 0, 0.2)' },
  itemShadowBlur: 20,
  loadMoreAmount: 'all',
  itemShadowDirection: 135,
  itemShadowSize: 10,
  imageInfoType: _consts2.default.infoType.NO_BACKGROUND,
  textBoxBorderRadius: 0,
  textBoxBorderWidth: 0,
  textBoxBorderColor: 'color-5',
  titleDescriptionSpace: 6,
  textsVerticalPadding: 0,
  textsHorizontalPadding: 0,
  textBoxFillColor: 'color-2',
  textBoxHeight: 200,
  textImageSpace: 10,
  alwaysShowHover: false,
  isStoreGallery: false,
  previewHover: false,
  calculateTextBoxHeightMode: _consts2.default.calculationOptions.AUTOMATIC
};

var getDefaultStyles = function getDefaultStyles(isMobile, isStoreGallery) {
  baseDefaultStyles.galleryLayout = isStoreGallery ? 2 : 0;
  baseDefaultStyles.thumbnailSize = isMobile ? 90 : 120;
  baseDefaultStyles.useCustomButton = isStoreGallery;
  baseDefaultStyles.isStoreGallery = isStoreGallery;
  return baseDefaultStyles;
};

var convertToMobileSettingIfNeeded = function convertToMobileSettingIfNeeded(isMobile, styles) {
  if (isMobile) {
    (0, _keys2.default)(styles).forEach(function (val) {
      if (val.startsWith('m_')) {
        styles[val.slice(2)] = styles[val];
      }
    });
  }
  return styles;
};

var getProGalleryStylesImp = exports.getProGalleryStylesImp = function getProGalleryStylesImp(wixStyles, gotStyleParams, options) {
  var isMobile = options.isMobile,
      isStoreGallery = options.isStoreGallery,
      isOnBoarding = options.isOnBoarding;


  var defaultStateStyles = getDefaultStyles(isMobile, isStoreGallery);

  var stateStyles = {}; //Object.assign({}, this.props.styles || {}, this.props.behaviour || {}, this.newProps.styles || {}, this.newProps.behaviour || {}, window.styles || {}, window.behaviour || {});
  function canSet(wixParam, stateParam) {
    // wixStyles    =>  Styles arrived directly from wix
    // stateStyles  =>  The result of the styles format
    // wixParam     =>  The name of the parameter in wixParams
    // stateParam   =>  The name of the parameter in the formatted styles result
    if (isUndefined(stateParam)) {
      // the wixParam and stateParam have the same names
      // check that the wixParam is not already set in the stateStyles AND wixStyles have it
      return isUndefined(stateStyles[wixParam]) && !isUndefined(wixStyles[wixParam]);
    } else {
      // the stateParam and wixParam have different names
      // check that the stateParam is not already set in the stateStyles AND wixStyles have the wixParam
      return isUndefined(stateStyles[stateParam]) && !isUndefined(wixStyles[wixParam]);
    }
  }

  wixStyles.gallerySize = wixStyles.gallerySize || 30;

  wixStyles = convertToMobileSettingIfNeeded(isMobile, wixStyles);

  if (String(wixStyles.mobilePanorama) === '1' && isMobile) {
    stateStyles.galleryLayout = 6;
    stateStyles.rotatingGroupTypes = '1';
    stateStyles.isVertical = true;
    stateStyles.numberOfImagesPerRow = 1;
    stateStyles.oneRow = false;
  }

  //behaviour
  if (canSet('alwaysShowHover')) {
    stateStyles.alwaysShowHover = wixStyles.alwaysShowHover;
  }

  if (canSet('previewHover')) {
    stateStyles.previewHover = wixStyles.previewHover;
  }

  if (canSet('fullscreen')) {
    stateStyles.fullscreen = wixStyles.fullscreen.toString() === '0';
  } else {
    stateStyles.fullscreen = true;
  }

  if (canSet('allowSocial')) {
    stateStyles.allowSocial = wixStyles.allowSocial;
  }

  if (canSet('allowHover')) {
    stateStyles.allowHover = wixStyles.allowHover;
  }

  if (canSet('allowTitle')) {
    stateStyles.allowTitle = isOnBoarding ? true : wixStyles.allowTitle;
  }

  if (canSet('isInAdi')) {
    stateStyles.isInAdi = wixStyles.isInAdi;
  }

  if (canSet('useCustomButton')) {
    stateStyles.useCustomButton = wixStyles.useCustomButton;
  }

  if (canSet('allowDescription')) {
    stateStyles.allowDescription = wixStyles.allowDescription;
  }

  if (canSet('allowDownload')) {
    stateStyles.allowDownload = wixStyles.allowDownload;
  }

  if (canSet('loveButton')) {
    stateStyles.loveButton = wixStyles.loveButton;
  }

  //note: 0 is true and false is 1 - super confusing (can't change it - because of backwards compatibility)
  if (canSet('loveCounter')) {
    stateStyles.loveCounter = String(wixStyles.loveCounter) === '0';
  }

  if (canSet('enableInfiniteScroll')) {
    stateStyles.enableInfiniteScroll = String(wixStyles.enableInfiniteScroll) === '1';
  }

  //design
  if (canSet('imageMargin')) {
    stateStyles.imageMargin = Number(wixStyles.imageMargin);
  }

  if (canSet('galleryMargin')) {
    stateStyles.galleryMargin = Number(wixStyles.galleryMargin);
  }

  if (canSet('isRTL')) {
    stateStyles.isRTL = String(wixStyles.isRTL) === '1';
  }
  if (canSet('isVertical')) {
    stateStyles.isVertical = String(wixStyles.isVertical) === '1';
  }
  if (canSet('imageOrientation', 'isVertical')) {
    stateStyles.isVertical = String(wixStyles.imageOrientation) === '1';
  }

  if (canSet('collageAmount')) {
    stateStyles.collageAmount = Number(wixStyles.collageAmount) / 10;
  }

  if (canSet('collageDensity')) {
    stateStyles.collageDensity = Number(wixStyles.collageDensity) / 100;
  }

  if (canSet('minItemSize')) {
    stateStyles.minItemSize = wixStyles.minItemSize;
  }

  if (canSet('gallerySize')) {
    stateStyles.gallerySize = wixStyles.gallerySize;
  }

  if (canSet('magicLayoutSeed')) {
    stateStyles.magicLayoutSeed = wixStyles.magicLayoutSeed;
  }

  if (canSet('gallerySizePx')) {
    stateStyles.gallerySizePx = wixStyles.gallerySizePx;
  }

  if (canSet('gallerySizeRatio')) {
    stateStyles.gallerySizeRatio = wixStyles.gallerySizeRatio;
  }

  if (canSet('gallerySizeType')) {
    stateStyles.gallerySizeType = ['smart', 'px', 'ratio'][Number(wixStyles.gallerySizeType)];
  }

  if (canSet('gridStyle')) {
    stateStyles.gridStyle = wixStyles.gridStyle;
  }

  if (canSet('groupSize')) {
    stateStyles.groupSize = Number(wixStyles.groupSize);
  }

  if (canSet('chooseBestGroup')) {
    stateStyles.chooseBestGroup = String(wixStyles.chooseBestGroup) === '1';
  }

  if (canSet('groupTypes')) {
    stateStyles.groupTypes = String(wixStyles.groupTypes);
  }

  if (canSet('rotatingGroupTypes')) {
    stateStyles.rotatingGroupTypes = String(wixStyles.rotatingGroupTypes);
  }

  if (canSet('rotatingCropRatios')) {
    stateStyles.rotatingCropRatios = String(wixStyles.rotatingCropRatios);
  }

  if (canSet('itemBorderWidth')) {
    stateStyles.itemBorderWidth = Number(wixStyles.itemBorderWidth);
  }

  if (canSet('itemBorderColor')) {
    stateStyles.itemBorderColor = wixStyles.itemBorderColor;
  }

  if (canSet('itemBorderRadius')) {
    stateStyles.itemBorderRadius = Number(wixStyles.itemBorderRadius);
  }

  if (canSet('itemShadowOpacityAndColor')) {
    stateStyles.itemShadowOpacityAndColor = wixStyles.itemShadowOpacityAndColor;
  }

  if (canSet('itemShadowBlur')) {
    stateStyles.itemShadowBlur = Number(wixStyles.itemShadowBlur);
  }

  if (canSet('itemShadowDirection')) {
    stateStyles.itemShadowDirection = Number(wixStyles.itemShadowDirection);
  }

  if (canSet('itemShadowSize')) {
    stateStyles.itemShadowSize = Number(wixStyles.itemShadowSize);
  }

  if (canSet('itemEnableShadow')) {
    stateStyles.itemEnableShadow = wixStyles.itemEnableShadow;
  }

  // testing a new way (with less text and less "ifs") TODO - ask guy if i should adopt it (90% of the items)
  // const styleFnMap = {
  // 	imageMargin: () =>  Number(wixStyles.imageMargin)
  // }

  // for (let key of Object.keys(wixStyles)) {
  // 	if (styleFnMap[key] && canSet(key)) {
  // 		stateStyles[key] = styleFnMap[key]()
  // 	}
  // }
  if (canSet('floatingImages')) {
    stateStyles.floatingImages = Number(wixStyles.floatingImages) / 100;
  }

  if (canSet('thumbnailSpacings')) {
    stateStyles.thumbnailSpacings = Number(wixStyles.thumbnailSpacings) / 2;
  }

  if (canSet('cubeImages')) {
    stateStyles.cubeImages = String(wixStyles.cubeImages) === '1';
  }

  if (canSet('smartCrop')) {
    stateStyles.smartCrop = String(wixStyles.smartCrop) === '1';
  }

  if (canSet('cubeRatio')) {
    stateStyles.cubeRatio = Number(eval(wixStyles.cubeRatio));
  }

  if (canSet('imageResize', 'cubeType')) {
    stateStyles.cubeType = String(wixStyles.imageResize) === '1' ? 'fit' : 'fill';
    if (stateStyles.cubeType === 'fit') {
      if (stateStyles.cropOnlyFill === true) {
        stateStyles.cubeImages = false;
      }
    }
  }
  //TODO, I changed it so that we will have the wixStyles, in the renderer I need to change the function to have the functionality of isSlider / isGrid - V
  //TODO should I add the new style names to the defaults as undefined? - no, i dont (should check with guy to make sure)
  if (canSet('gallerySliderImageRatio', 'cubeRatio')) {
    stateStyles.gallerySliderImageRatio = Number(eval(['16/9', '4/3', '1', '3/4', '9/16'][Number(wixStyles.gallerySliderImageRatio)]));
  } else if (isUndefined(stateStyles.cubeRatio)) {
    stateStyles.gallerySliderImageRatio = Number(eval(['16/9', '4/3', '1', '3/4', '9/16'][Number(defaultStateStyles.gallerySliderImageRatio)]));
  }
  if (canSet('galleryImageRatio', 'cubeRatio')) {
    stateStyles.galleryImageRatioFromWix = Number(eval(['16/9', '4/3', '1', '3/4', '9/16'][Number(wixStyles.galleryImageRatio)]));
  }

  if (canSet('fixedColumns')) {
    stateStyles.fixedColumns = Number(wixStyles.fixedColumns);
  }

  if (canSet('groupsPerStrip')) {
    stateStyles.groupsPerStrip = Number(wixStyles.groupsPerStrip);
  }

  if (canSet('scrollDirection', 'oneRow')) {
    stateStyles.oneRow = String(wixStyles.scrollDirection) === '1';

    if (stateStyles.oneRow) {
      //if oneRow is true, use horizontal layouts only
      stateStyles.isVertical = false;
    }
  }
  //TODO move to renderer - need to split again - V
  if (canSet('numberOfImagesPerRow')) {
    stateStyles.numberOfImagesPerRow = Number(wixStyles.numberOfImagesPerRow);
  } else {
    stateStyles.numberOfImagesPerRow = defaultStateStyles.numberOfImagesPerRow;
  }

  if (canSet('m_numberOfImagesPerRow')) {
    stateStyles.m_numberOfImagesPerRow = Number(wixStyles.m_numberOfImagesPerRow);
  }

  if (canSet('numberOfImagesPerCol')) {
    stateStyles.numberOfImagesPerCol = Number(wixStyles.numberOfImagesPerCol);
  }

  if (canSet('galleryThumbnailsAlignment')) {
    stateStyles.galleryThumbnailsAlignment = ['bottom', 'left', 'top', 'right'][wixStyles.galleryThumbnailsAlignment];
  }

  //There's some kunch-ptant here so support opacity, checkout .default css className usage
  // (If this style isn't defined, we add 'default' to the className, and there we all the default params)
  if (canSet('itemOpacity')) {
    stateStyles.itemOpacity = wixStyles.itemOpacity;
  }

  if (canSet('galleryLayout')) {
    stateStyles.galleryLayout = wixStyles.galleryLayout;
  }

  if (canSet('galleryType')) {
    stateStyles.galleryType = wixStyles.galleryType;
  }

  if (canSet('titlePlacement')) {
    if (String(wixStyles.titlePlacement) === '0') {
      stateStyles.titlePlacement = _consts2.default.placements.SHOW_BELOW;
    } else if (String(wixStyles.titlePlacement) === '2') {
      stateStyles.titlePlacement = _consts2.default.placements.SHOW_ABOVE;
    } else {
      //wixStyles.titlePlacement) === '1'
      stateStyles.titlePlacement = _consts2.default.placements.SHOW_ON_HOVER;
    }
  }

  if (canSet('hoveringBehaviour')) {
    if (String(wixStyles.hoveringBehaviour) === '1') {
      stateStyles.hoveringBehaviour = _consts2.default.infoBehaviourOnHover.DISAPPEARS;
    } else if (String(wixStyles.hoveringBehaviour) === '2') {
      stateStyles.hoveringBehaviour = _consts2.default.infoBehaviourOnHover.NO_CHANGE;
    } else {
      //String(wixStyles.hoveringBehaviour) === '0'
      stateStyles.hoveringBehaviour = _consts2.default.infoBehaviourOnHover.APPEARS;
    }
  }

  if (canSet('scrollAnimation')) {
    if (String(wixStyles.scrollAnimation) === '1') {
      stateStyles.scrollAnimation = _consts2.default.scrollAnimations.FADE_IN;
    } else if (String(wixStyles.scrollAnimation) === '2') {
      stateStyles.scrollAnimation = _consts2.default.scrollAnimations.GRAYSCALE;
    } else if (String(wixStyles.scrollAnimation) === '3') {
      stateStyles.scrollAnimation = _consts2.default.scrollAnimations.SLIDE_UP;
    } else if (String(wixStyles.scrollAnimation) === '4') {
      stateStyles.scrollAnimation = _consts2.default.scrollAnimations.EXPAND;
    } else if (String(wixStyles.scrollAnimation) === '5') {
      stateStyles.scrollAnimation = _consts2.default.scrollAnimations.SHRINK;
    } else if (String(wixStyles.scrollAnimation) === '6') {
      stateStyles.scrollAnimation = _consts2.default.scrollAnimations.ZOOM_OUT;
    } else if (String(wixStyles.scrollAnimation) === '7') {
      stateStyles.scrollAnimation = _consts2.default.scrollAnimations.ONE_COLOR;
    } else {
      //String(wixStyles.scrollAnimation) === '0'
      stateStyles.scrollAnimation = _consts2.default.scrollAnimations.NO_EFFECT;
    }
  }

  if (canSet('overlayAnimation')) {
    if (String(wixStyles.overlayAnimation) === '1') {
      stateStyles.overlayAnimation = _consts2.default.overlayAnimations.FADE_IN;
    } else if (String(wixStyles.overlayAnimation) === '2') {
      stateStyles.overlayAnimation = _consts2.default.overlayAnimations.EXPAND;
    } else if (String(wixStyles.overlayAnimation) === '3') {
      stateStyles.overlayAnimation = _consts2.default.overlayAnimations.SLIDE_UP;
    } else if (String(wixStyles.overlayAnimation) === '4') {
      stateStyles.overlayAnimation = _consts2.default.overlayAnimations.SLIDE_RIGHT;
    } else {
      //String(wixStyles.overlayAnimation) === '0'
      stateStyles.overlayAnimation = _consts2.default.overlayAnimations.NO_EFFECT;
    }
  }

  if (canSet('imageHoverAnimation')) {
    if (String(wixStyles.imageHoverAnimation) === '1') {
      stateStyles.imageHoverAnimation = _consts2.default.imageHoverAnimations.ZOOM_IN;
    } else if (String(wixStyles.imageHoverAnimation) === '2') {
      stateStyles.imageHoverAnimation = _consts2.default.imageHoverAnimations.BLUR;
    } else if (String(wixStyles.imageHoverAnimation) === '3') {
      stateStyles.imageHoverAnimation = _consts2.default.imageHoverAnimations.GRAYSCALE;
    } else if (String(wixStyles.imageHoverAnimation) === '4') {
      stateStyles.imageHoverAnimation = _consts2.default.imageHoverAnimations.SHRINK;
    } else if (String(wixStyles.imageHoverAnimation) === '5') {
      stateStyles.imageHoverAnimation = _consts2.default.imageHoverAnimations.INVERT;
    } else if (String(wixStyles.imageHoverAnimation) === '6') {
      stateStyles.imageHoverAnimation = _consts2.default.imageHoverAnimations.COLOR_IN;
    } else if (String(wixStyles.imageHoverAnimation) === '7') {
      stateStyles.imageHoverAnimation = _consts2.default.imageHoverAnimations.DARKENED;
    } else {
      //String(wixStyles.imageHoverAnimation) === '0'
      stateStyles.imageHoverAnimation = _consts2.default.imageHoverAnimations.NO_EFFECT;
    }
  }

  if (canSet('expandAnimation')) {
    if (String(wixStyles.expandAnimation) === '1') {
      stateStyles.expandAnimation = _consts2.default.expandAnimations.EXPAND;
    } else if (String(wixStyles.expandAnimation) === '2') {
      stateStyles.expandAnimation = _consts2.default.expandAnimations.FADE_IN;
    } else if (String(wixStyles.expandAnimation) === '3') {
      stateStyles.expandAnimation = _consts2.default.expandAnimations.ZOOM;
    } else {
      //String(wixStyles.expandAnimation) === '0'
      stateStyles.expandAnimation = _consts2.default.expandAnimations.NO_EFFECT;
    }
  }

  if (canSet('itemFont')) {
    stateStyles.itemFont = wixStyles.itemFont;
  }

  if (canSet('itemFontSlideshow')) {
    stateStyles.itemFontSlideshow = wixStyles.itemFontSlideshow;
  }

  if (canSet('itemDescriptionFontSlideshow')) {
    stateStyles.itemDescriptionFontSlideshow = wixStyles.itemDescriptionFontSlideshow;
  }

  if (canSet('itemDescriptionFont')) {
    stateStyles.itemDescriptionFont = wixStyles.itemDescriptionFont;
  }

  if (canSet('itemFontColor')) {
    stateStyles.itemFontColor = wixStyles.itemFontColor;
  }

  // We need another param because the color should be different on hover(white on black) or underneath (black on white)
  if (canSet('itemFontColorSlideshow')) {
    stateStyles.itemFontColorSlideshow = wixStyles.itemFontColorSlideshow;
  }

  if (canSet('itemDescriptionFontColor')) {
    stateStyles.itemDescriptionFontColor = wixStyles.itemDescriptionFontColor;
  }

  if (canSet('itemDescriptionFontColorSlideshow')) {
    stateStyles.itemDescriptionFontColorSlideshow = wixStyles.itemDescriptionFontColorSlideshow;
  }

  if (canSet('textBoxFillColor')) {
    stateStyles.textBoxFillColor = wixStyles.textBoxFillColor;
  }

  if (canSet('textBoxHeight')) {
    stateStyles.textBoxHeight = wixStyles.textBoxHeight;
  }

  if (canSet('textsVerticalPadding')) {
    stateStyles.textsVerticalPadding = wixStyles.textsVerticalPadding;
  }

  if (canSet('textsHorizontalPadding')) {
    stateStyles.textsHorizontalPadding = wixStyles.textsHorizontalPadding;
  }

  if (canSet('textBoxBorderRadius')) {
    stateStyles.textBoxBorderRadius = Number(wixStyles.textBoxBorderRadius);
  }

  if (canSet('textBoxBorderWidth')) {
    stateStyles.textBoxBorderWidth = Number(wixStyles.textBoxBorderWidth);
  }

  if (canSet('textBoxBorderColor')) {
    stateStyles.textBoxBorderColor = wixStyles.textBoxBorderColor;
  }

  if (canSet('titleDescriptionSpace')) {
    stateStyles.titleDescriptionSpace = Number(wixStyles.titleDescriptionSpace);
  }

  if (canSet('textImageSpace')) {
    stateStyles.textImageSpace = wixStyles.textImageSpace;
  }

  if (canSet('imageInfoType')) {
    var selectedImageInfoType = void 0;
    if (String(wixStyles.imageInfoType) === '0') {
      selectedImageInfoType = _consts2.default.infoType.NO_BACKGROUND;
    } else if (String(wixStyles.imageInfoType) === '1') {
      selectedImageInfoType = _consts2.default.infoType.ATTACHED_BACKGROUND;
    } else if (String(wixStyles.imageInfoType) === '2') {
      selectedImageInfoType = _consts2.default.infoType.SEPARATED_BACKGROUND;
    } else {
      selectedImageInfoType = _consts2.default.infoType.NO_BACKGROUND;
    }
    stateStyles.imageInfoType = selectedImageInfoType;
  }

  if (canSet('galleryHorizontalAlign')) {
    var horizontalAlign = void 0;
    var textAlign = void 0;
    switch (wixStyles.galleryHorizontalAlign) {
      case 0:
        horizontalAlign = 'flex-start';
        textAlign = 'left';
        break;
      case 1:
      default:
        horizontalAlign = 'center';
        textAlign = 'center';
        break;
      case 2:
        horizontalAlign = 'flex-end';
        textAlign = 'right';
        break;
    }

    stateStyles.galleryHorizontalAlign = horizontalAlign;
    stateStyles.galleryTextAlign = textAlign;
  }

  if (canSet('galleryVerticalAlign')) {
    var verticalAlign = void 0;
    switch (wixStyles.galleryVerticalAlign) {
      case 0:
      default:
        verticalAlign = 'flex-start';
        break;
      case 1:
        verticalAlign = 'center';
        break;
      case 2:
        verticalAlign = 'flex-end';
        break;
    }
    stateStyles.galleryVerticalAlign = verticalAlign;
  }

  if (canSet('itemClick')) {
    if (typeof wixStyles.itemClick === 'number') {
      switch (wixStyles.itemClick) {
        case 0:
        default:
          stateStyles.itemClick = 'expand';
          break;
        case 1:
          stateStyles.itemClick = 'link';
          break;
        case 2:
          stateStyles.itemClick = 'nothing';
          break;
        case 3:
          stateStyles.itemClick = 'fullscreen';
          break;
      }
    } else if (wixStyles.itemClick === 'expand' || wixStyles.itemClick === 'link' || wixStyles.itemClick === 'nothing' || wixStyles.itemClick === 'fullscreen') {
      stateStyles.itemClick = wixStyles.itemClick;
    } else {
      stateStyles.itemClick = 'expand';
    }
  }

  if (canSet('loadMoreButtonText')) {
    stateStyles.loadMoreButtonText = String(wixStyles.loadMoreButtonText);
  }
  if (canSet('loadMoreButtonFont')) {
    stateStyles.loadMoreButtonFont = wixStyles.loadMoreButtonFont;
  }
  if (canSet('loadMoreButtonFontColor')) {
    stateStyles.loadMoreButtonFontColor = wixStyles.loadMoreButtonFontColor;
  }
  if (canSet('loadMoreButtonColor')) {
    stateStyles.loadMoreButtonColor = wixStyles.loadMoreButtonColor;
  }
  if (canSet('loadMoreButtonBorderWidth')) {
    stateStyles.loadMoreButtonBorderWidth = wixStyles.loadMoreButtonBorderWidth;
  }
  if (canSet('loadMoreButtonBorderColor')) {
    stateStyles.loadMoreButtonBorderColor = wixStyles.loadMoreButtonBorderColor;
  }
  if (canSet('loadMoreButtonBorderRadius')) {
    stateStyles.loadMoreButtonBorderRadius = wixStyles.loadMoreButtonBorderRadius;
  }

  if (canSet('loadMoreAmount')) {
    if (String(wixStyles.loadMoreAmount) === '1') {
      stateStyles.loadMoreAmount = 'partial';
    } else {
      //String(wixStyles.loadMoreAmount) === '0'
      stateStyles.loadMoreAmount = 'all';
    }
  }

  if (canSet('customButtonText')) {
    stateStyles.customButtonText = String(wixStyles.customButtonText);
  } else if (isStoreGallery) {
    stateStyles.customButtonText = 'Buy Now';
  }

  // defaults - need to leave here to have it defined
  stateStyles.sharpParams = {
    quality: 90,
    usm: {}
  };

  if (canSet('imageQuality')) {
    stateStyles.sharpParams.quality = wixStyles.imageQuality;
  }

  if (canSet('usmToggle')) {
    stateStyles.sharpParams.allowUsm = wixStyles.usmToggle;

    if (wixStyles.usmToggle === true) {
      if (canSet('usm_a')) {
        stateStyles.sharpParams.usm.usm_a = (wixStyles.usm_a || 0) / 100;
      }
      if (canSet('usm_r')) {
        stateStyles.sharpParams.usm.usm_r = wixStyles.usm_r;
      }
      if (canSet('usm_t')) {
        stateStyles.sharpParams.usm.usm_t = (wixStyles.usm_t || 0) / 255;
      }
    }
  }

  if (canSet('videoPlay')) {
    switch (wixStyles.videoPlay) {
      case 0:
      default:
        stateStyles.videoPlay = 'hover';
        break;
      case 1:
        stateStyles.videoPlay = 'auto';
        break;
      case 2:
        stateStyles.videoPlay = 'onClick';
        break;
    }
  }
  if (canSet('videoSound')) {
    stateStyles.videoSound = wixStyles.videoSound;
  }
  if (canSet('videoSpeed')) {
    stateStyles.videoSpeed = wixStyles.videoSpeed;
  }
  if (canSet('videoLoop')) {
    stateStyles.videoLoop = wixStyles.videoLoop;
  }
  if (canSet('mobilePanorama')) {
    stateStyles.mobilePanorama = String(wixStyles.mobilePanorama) === '1';
  }
  if (canSet('placeGroupsLtr')) {
    stateStyles.placeGroupsLtr = String(wixStyles.placeGroupsLtr) === '1';
  }
  if (canSet('isAutoSlideshow')) {
    stateStyles.isAutoSlideshow = String(wixStyles.isAutoSlideshow) === '1';
  }
  if (canSet('slideshowLoop')) {
    stateStyles.slideshowLoop = String(wixStyles.slideshowLoop) === '1';
  }
  if (canSet('playButtonForAutoSlideShow')) {
    stateStyles.playButtonForAutoSlideShow = String(wixStyles.playButtonForAutoSlideShow) === '1';
  }
  if (canSet('allowSlideshowCounter')) {
    stateStyles.allowSlideshowCounter = wixStyles.allowSlideshowCounter;
  }
  if (canSet('autoSlideshowInterval')) {
    stateStyles.autoSlideshowInterval = Number(wixStyles.autoSlideshowInterval) || 0;
  }
  if (canSet('arrowsSize')) {
    stateStyles.arrowsSize = Number(wixStyles.arrowsSize) || 23;
  }
  if (canSet('arrowsColor')) {
    stateStyles.arrowsColor = wixStyles.arrowsColor;
  }
  if (canSet('arrowsPosition')) {
    stateStyles.arrowsPosition = wixStyles.arrowsPosition;
  }
  if (canSet('oneColorAnimationColor')) {
    stateStyles.oneColorAnimationColor = wixStyles.oneColorAnimationColor;
  }
  if (canSet('slideshowInfoSize')) {
    stateStyles.slideshowInfoSize = Number(wixStyles.slideshowInfoSize);
  }
  if (canSet('thumbnailSize')) {
    stateStyles.thumbnailSize = isMobile ? defaultStateStyles.thumbnailSize : Number(wixStyles.thumbnailSize) || defaultStateStyles.thumbnailSize;
  }

  if (canSet('imageLoadingMode')) {
    if (String(wixStyles.imageLoadingMode) === '1') {
      stateStyles.imageLoadingMode = _consts2.default.loadingMode.COLOR;
    } else {
      //String(wixStyles.imageLoadingMode) === '0'
      stateStyles.imageLoadingMode = _consts2.default.loadingMode.BLUR;
    }
  }

  if (canSet('calculateTextBoxHeightMode')) {
    if (String(wixStyles.calculateTextBoxHeightMode) === '1') {
      stateStyles.calculateTextBoxHeightMode = _consts2.default.calculationOptions.MANUAL;
    } else {
      //String(wixStyles.calculateTextBoxHeightMode) === '0'
      stateStyles.calculateTextBoxHeightMode = _consts2.default.calculationOptions.AUTOMATIC;
    }
  }

  stateStyles.gotStyleParams = gotStyleParams;

  var finalStyleParams = (0, _extends3.default)({}, defaultStateStyles, stateStyles);

  return finalStyleParams;
};

var getProGalleryStyles = exports.getProGalleryStyles = function getProGalleryStyles(wixStyles) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var defaultOptions = {
    isMobile: false,
    isStoreGallery: false,
    isOnBoarding: false
  };
  var spreadStyles = (0, _extends3.default)({}, wixStyles.booleans, wixStyles.numbers, wixStyles.colors, wixStyles.fonts, wixStyles.manual);
  return getProGalleryStylesImp(spreadStyles, true, (0, _extends3.default)({}, defaultOptions, options));
};